module.exports = __webpack_public_path__ + "static/media/SerenityBold.639f1a63.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SerenityBold.ttf
// module id = 2233
// module chunks = 47